import React from 'react'
import type { StatCardProps } from './types'
import {
  StyledStatCard,
  StatInfoContainer,
  StatName,
  StatValue,
  ComplementaryInfo,
  IconContainer,
} from './styles'
import { fieldToStatNameMap } from '../../../../../../Constant/statsProcess'

export const StatCard: React.FC<StatCardProps> = ({
  statName,
  statValue,
  complimentaryStats,
  icon,
}) => {
  const getShortStatName = (statName: string) => {
    const shortStatName = fieldToStatNameMap[statName]
    return shortStatName || statName
  }

  return (
    <StyledStatCard>
      <StatInfoContainer>
        <StatName>{statName}</StatName>
        <StatValue>{statValue}</StatValue>
        {complimentaryStats && complimentaryStats.length > 0 && (
          <ComplementaryInfo>
            {complimentaryStats.map((stat) => (
              <div key={stat.name}>
                <span className="val">{`${stat.value}`}</span>
                <span className="label">{`${getShortStatName(stat.name)}`}</span>
              </div>
            ))}
          </ComplementaryInfo>
        )}
      </StatInfoContainer>
      {icon && <IconContainer>{icon}</IconContainer>}
    </StyledStatCard>
  )
}
